module.exports = __webpack_public_path__ + "06_long_grey.445dea75.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/06_long_grey.png
// module id = +QcI
// module chunks = 0